"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _semanticUiReact = require("semantic-ui-react");

var _formatNumber = _interopRequireDefault(require("format-number"));

var _Fonts = require("../00_environment/Fonts");

var _BlockWithLeftHeader = _interopRequireDefault(require("../01_atoms/BlockWithLeftHeader"));

var _CentralPaneWrapper = _interopRequireDefault(require("../01_atoms/CentralPaneWrapper"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer.rc"));

var _TitledContainer2 = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _PaymentIcon = _interopRequireDefault(require("../01_atoms/PaymentIcon"));

var _PaymentMethodCard = _interopRequireDefault(require("../01_atoms/PaymentMethodCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var PaymentPaneWidget = function PaymentPaneWidget(_ref) {
  var t = _ref.translator,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$canSubmit = _ref.canSubmit,
      canSubmit = _ref$canSubmit === void 0 ? function () {} : _ref$canSubmit,
      _ref$submit = _ref.submit,
      submit = _ref$submit === void 0 ? function () {} : _ref$submit,
      _ref$setState = _ref.setState,
      setState = _ref$setState === void 0 ? function () {} : _ref$setState,
      numberOfPassengers = _ref.numberOfPassengers,
      payAmount = _ref.payAmount,
      elementsOptions = _ref.elementsOptions,
      error = _ref.error,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      stripe = _ref.stripe;
  return /*#__PURE__*/_react["default"].createElement(_CentralPaneWrapper["default"], {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_TitledContainer2["default"], {
    title: t('Payment details'),
    rightButtonText: t('Back'),
    onRightButtonClick: onBack,
    noSidePadding: isMobile,
    fullHeight: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_BlockWithLeftHeader["default"], {
    noContentPadding: isMobile,
    style: {
      minHeight: '40vh'
    },
    ribbonContent: t('{x} ticket{s}', {
      x: numberOfPassengers,
      s: numberOfPassengers > 1 ? 's' : ''
    }),
    headerContent: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '2.8rem',
        fontWeight: '600',
        marginBottom: 30
      }
    }, formatPrice(payAmount)), /*#__PURE__*/_react["default"].createElement(_PaymentMethodCard["default"], {
      highlighted: true,
      text: t('By credit card'),
      icons: [/*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        key: "payment-icons-1"
      }, /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "visa",
        key: "visa",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      }), /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "mastercard",
        key: "mastercard",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      }), /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "amex",
        key: "amex",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        key: "payment-icons-2"
      }, /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "diners",
        key: "diners",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      }), /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "discover",
        key: "discover",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      }), /*#__PURE__*/_react["default"].createElement(_PaymentIcon["default"], {
        id: "maestro",
        key: "maestro",
        style: {
          height: '1.5rem',
          marginLeft: 5
        }
      })))]
    }))
  }, /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Enter your credit card details'),
    wrapTitle: true,
    backgroundColor: "none",
    fontSize: "1.2rem"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
      marginTop: 0,
      marginBottom: 20,
      outline: '0',
      WebkitAppearance: 'none',
      tapHighlightColor: 'rgba(255,255,255,0)',
      lineHeight: '1.21428571em',
      padding: '.67857143em 1em',
      fontSize: '1em',
      background: '#fff',
      border: '1px solid rgba(34,36,38,.15)',
      color: 'rgba(0,0,0,.87)',
      borderRadius: '.28571429rem',
      boxShadow: '0 0 0 0 transparent inset',
      transition: 'color .1s ease,border-color .1s ease'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeElements.CardElement, _extends({
    onChange: function onChange(e) {
      return setState({
        cardComplete: e.complete
      });
    }
  }, elementsOptions)))), error && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
    negative: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message.Header, null, t('There was an error with your payment')), /*#__PURE__*/_react["default"].createElement("p", null, error.message)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !canSubmit(),
    primary: !error,
    fluid: true,
    onClick: function onClick() {
      return submit(stripe);
    }
  }, !payAmount && t('Pay now'), payAmount > 0 && (error ? t('Retry payment of {amount}', {
    amount: formatPrice(payAmount)
  }) : t('Pay {amount}', {
    amount: formatPrice(payAmount)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      marginTop: 15
    })
  }, t('By booking a ticket, you accept our terms of use.')))))));
};

var _default = (0, _reactStripeElements.injectStripe)(PaymentPaneWidget);

exports["default"] = _default;